import React from "react";
import ConnectorPanel from "./ConnectorPanel";

// NinjaOne RMM.
//
// Three values: the region, and the client id/secret of an API app created inside the
// customer's own NinjaOne instance. Nothing is registered on our side — NinjaOne's
// machine-to-machine flow means each workspace issues its own credential, so there is no
// platform app to install and no marketplace review in the way.
//
// Region is a fixed choice rather than a URL. NinjaOne runs one instance per region and
// an account exists on exactly one of them; the host is derived server-side from this
// value, because a free-form host on a stored credential is a way to aim that credential
// at somebody else's server.

const FIELDS = [
  {
    key: "region",
    label: "Region",
    required: true,
    options: [
      { value: "us", label: "United States (app.ninjarmm.com)" },
      { value: "us2", label: "United States 2 (us2.ninjarmm.com)" },
      { value: "eu", label: "Europe (eu.ninjarmm.com)" },
      { value: "ca", label: "Canada (ca.ninjarmm.com)" },
      { value: "oc", label: "Oceania (oc.ninjarmm.com)" },
    ],
    help: "The instance your NinjaOne account signs in to — check the address bar.",
  },
  {
    key: "client_id",
    label: "Client ID",
    required: true,
    help: "Administration → Apps → API → Client app IDs.",
  },
  {
    key: "client_secret",
    label: "Client secret",
    secret: true,
    required: true,
    help: "Shown once when the client app is created. It cannot be read back afterwards.",
  },
];

const HELP = {
  summary: "Match scanned hosts to NinjaOne devices and pull their OS and asset detail.",
  customerNoun: "NinjaOne organization",
  steps: [
    "In NinjaOne, go to Administration → Apps → API and open the Client app IDs tab.",
    "Add a client app of type API Services (machine-to-machine).",
    "Grant it the monitoring and management scopes. This connector only ever reads.",
    "Copy the Client ID and the Client Secret — the secret is shown once.",
    "Pick your region, paste both values here, press Connect, then Test connection.",
  ],
};

const NinjaOnePanel = ({ isAdmin }) => (
  <ConnectorPanel
    isAdmin={isAdmin}
    provider="ninjaone"
    title="NinjaOne"
    fields={FIELDS}
    help={HELP}
  />
);

export default NinjaOnePanel;
